import {
  MotionBox as Box,
  staggeredAppear,
  viewAppearDefault,
} from "utils/motion";
import Text from "components/base/Text";
import Container from "components/base/Container";

export default function SmallTextSection({
  title,
  subtitle,
  text,
  inverted,
  containerProps,
  ...props
}) {
  const textAlign = props.textAlign || ["left", null, "center"];
  return (
    <Box
      width="100%"
      bg={inverted ? "white" : "black.700"}
      {...props}
      title={null}
    >
      <Container
        as="section"
        centerContent={textAlign != "left"}
        justifyContent="center"
        {...containerProps}
      >
        <Box
          maxW="lg"
          variants={staggeredAppear}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <Box variants={viewAppearDefault}>
            <Text type="title_md" color="primary" textAlign={textAlign}>
              {subtitle}
            </Text>
          </Box>
          <Box variants={viewAppearDefault}>
            <Text
              type="headline_md"
              color={inverted ? "black.900" : "white"}
              textAlign={textAlign}
              pt={[1, 1, 2]}
              pb={[3, 3, 5]}
            >
              {title}
            </Text>
          </Box>
          <Box variants={viewAppearDefault}>
            <Text
              type="p_lg"
              color={inverted ? "black.900" : "white"}
              textAlign={textAlign}
              fontSize={["20px", null, "28px"]}
            >
              {text}
            </Text>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
